import React, {useState, useEffect} from 'react'
import './Header.css'
import { MdMenu } from "react-icons/md";

function Header({language, changeLanguage, scrollToAbout, scrollToServices, scrollToContact}) {
    
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 1024);
        };
    
        // Initial check
        handleResize();
    
        // Listen for window resize event
        window.addEventListener('resize', handleResize);
    
        // Cleanup
        return () => window.removeEventListener('resize', handleResize);
    });

    const [menuOpen, setMenuOpen] = useState(false);
    const toggleMenu = () =>{
        setMenuOpen(!menuOpen);
    }

    return (
        <header className='header_container'>
                {isSmallScreen === false ? (
                    <div className='header_content'>
                        <div className='header_logo'>
                            <img style={{height: '50px', width: 'auto'}} src='Logo_white.png' alt="Logo"/>
                        </div>
                        <div className='header_nav'>
                            <p onClick={scrollToAbout}>{language === 'deutsch' ? 'Über uns' : 'About us'}</p>
                            <p onClick={scrollToServices}>{language === 'deutsch' ? 'Leistungen' : 'Services'}</p>
                            <p onClick={scrollToContact}>{language === 'deutsch' ? 'Kontakt' : 'Contact'}</p>
                            <div style={{display: 'flex', gap: '10px'}}>
                                <img style={{width: '22px', cursor: 'pointer'}} src='res/img/d_flag.png' alt="Flag1" onClick={() => changeLanguage('deutsch')}/>
                                <img style={{width: '22px', cursor: 'pointer'}} src='res/img/uk_flag.png' alt="Flag2" onClick={() => changeLanguage('english')}/>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className='header_content'>
                        <div className='header_top'>
                            <img style={{height: '35px', width: 'auto'}} src='Logo_white.png' alt="Logo"/>
                            <MdMenu style={{scale: '1.5', cursor: 'pointer'}} onClick={() => toggleMenu()}/>
                        </div>
                        {menuOpen === true ? (
                            <div className='header_menu'>
                                <p onClick={scrollToAbout}>{language === 'deutsch' ? 'Über uns' : 'About us'}</p>
                                <p onClick={scrollToServices}>{language === 'deutsch' ? 'Leistungen' : 'Services'}</p>
                                <p onClick={scrollToContact}>{language === 'deutsch' ? 'Kontakt' : 'Contact'}</p>
                                <div style={{display: 'flex', gap: '25px'}}>
                                    <img style={{width: '28px', cursor: 'pointer'}} src='res/img/d_flag.png' alt="Flag1" onClick={() => changeLanguage('deutsch')}/>
                                    <img style={{width: '28px', cursor: 'pointer'}} src='res/img/uk_flag.png' alt="Flag2" onClick={() => changeLanguage('english')}/>
                                </div>
                            </div>
                        ) : null}
                    </div>
                )}
        </header>
    )
}

export default Header